IncidenciaActionsService.$inject = ['$log', 'dialogService', '$http', 'Incidencia', 'dialogConfirmService'];
export default function IncidenciaActionsService($log, dialogService, $http, Incidencia, dialogConfimService) {

    var TAG = 'IncidenciaActionsService: ';

    var DIALOG_EDITAR_INCIDENCIA_ID = 'dialogEditarIncidencia';
    var DIALOG_EDITAR_INCIDENCIA_TEMPLATE = require('./editIncidenciaDialog.html');
    var DIALOG_EDIT_FECHA_ID = 'dialogEditFecha';
    var DIALOG_EDIT_FECHA_TEMPLATE = require('./dialog-edit-fecha/dialog-edit-fecha.html');

    function editarOrigenOExpediente(incidenciaId, tareaId, tipo) {
        $log.debug(TAG + 'Editando origen de la incidencia ' + incidenciaId + ' ...');
        $log.debug('Tipo ' + tipo);

        Incidencia.edit({incidenciaId: incidenciaId}, function (data) {
            var opcionesExtra = {
                botonOk: ucfirst(Lang.get('nombres.editar')),
                botonCancel: ucfirst(Lang.get('nombres.cancelar'))
            };

            if (issetAndNotEmpty(tipo) && tipo == 'emplazamiento') {
                data.soloEmplazamiento = true;
            }

            var titulo = ucfirst(Lang.get('nombres.editar')) + " " + Lang.choice('nombres.incidencia', 1);
            var options = {
                title: titulo
            };

            dialogService.open(DIALOG_EDITAR_INCIDENCIA_ID, DIALOG_EDITAR_INCIDENCIA_TEMPLATE, data, options, opcionesExtra)
                .then(function (result) {
                    editarIncidenciaServer(incidenciaId, tareaId, result)
                });
        }, function (error) {
            Sigo.UI.Messages.open([error.data.messages], 0);
        });
    }

    function editarIncidenciaServer(incidenciaId, tareaId, incidencia) {
        $log.debug(TAG + 'Editando la incidencia ' + incidenciaId + '...');

        if (tareaId != null)
            incidencia['tarea_id'] = tareaId;

        Incidencia.update({incidenciaId: incidenciaId}, incidencia, function (data) {
            $log.debug('Incidencia editada!');
            if (tareaId != null) {
                actualizaFilaVTarea(data.vTarea);
            } else {
                actualizaFilaVIncidencia(data.vIncidencia, 0);
            }
        });
    }

    function _editarFecha(incidenciaId, fechaActual) {
        $log.debug(TAG + 'Abriendo modal para editar la fecha de la incidencia ' + incidenciaId + '...');

        var data = {
            incidenciaId: incidenciaId,
            fecha: moment(fechaActual, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY HH:mm:ss")
        };
        var options = {title: ucfirst(Lang.get('nombres.editar')) + " " + Lang.choice('nombres.fecha', 1)};//TODO:traducir
        var opcionesExtra = {deshabilitarBotones: true, devolverDatos: true};
        return dialogService.open(DIALOG_EDIT_FECHA_ID, DIALOG_EDIT_FECHA_TEMPLATE, data, options, opcionesExtra);
    }

    function _rechazarIncidencia(incidenciaId, mostrarPlantilla) {
        var DIALOG_RECHAZAR_INCIDENCIA_ID = 'dialog-rechazar-incidencia';
        var DIALOG_RECHAZAR_INCIDENCIA_TEMPLATE = require('./rechazar/incidencia-rechazar-dialog.html');

        $log.debug(TAG + 'Abriendo modal para editar la fecha de la incidencia ' + incidenciaId + '...');

        var data = {incidenciaId: incidenciaId, mostrarPlantilla: mostrarPlantilla};
        var options = {title: ucfirst(Lang.get('nombres.rechazar')) + " " + Lang.choice('nombres.incidencia', 1)};
        var opcionesExtra = {deshabilitarBotones: true, devolverDatos: true};

        return dialogService.open(DIALOG_RECHAZAR_INCIDENCIA_ID, DIALOG_RECHAZAR_INCIDENCIA_TEMPLATE, data, options, opcionesExtra);
    }

    function _borrarIncidencia(incidenciaId) {
        return new Promise((resolve, reject) => {
            let dataDialog = {
                botonOk: ucfirst(Lang.get('nombres.borrar'))
            };

            dialogConfimService.open(Lang.get('mensajes.confirm_borrar_incidencia'), dataDialog)
                .then(() => {
                    let promise = $http.get(Sigo.var.path + '/incidencias/borrar-incidencia/' + incidenciaId);
                    promise.then((data) => {
                            resolve(data.data);
                        }
                    );
                    promise.catch((error) => {
                        reject(error.data);
                    });

                });
        });
    }

    return {
        editarOrigenOExpediente: editarOrigenOExpediente,
        editarFecha: _editarFecha,
        rechazarIncidencia: _rechazarIncidencia,
        borrarIncidencia: _borrarIncidencia
    };
}